export default __webpack_public_path__ + "static/media/naoMasQueroCriar.533be041.svg";